import { render } from "./AutoClipToggleSwitch.vue?vue&type=template&id=777df124&scoped=true&ts=true"
import script from "./AutoClipToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./AutoClipToggleSwitch.vue?vue&type=script&lang=ts"

import "./AutoClipToggleSwitch.vue?vue&type=style&index=0&id=777df124&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777df124"]])

export default __exports__